import React from 'react';

import {ErrorBoundary} from '@sentry/react';
import {StepHeader} from 'src/components/step-header';

import {Group, Item} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';

import {CreateAccountProgressBar} from './components/progress-bar/progress-bar.component';
import {STEP_TITLE} from './steps';

import {
    createAccount,
    createAccountHeader,
    createAccountTitle,
} from './create-account.module.styl';

import type {CREATE_ACCOUNT_STEPS} from './steps';
import type {ReactNode} from 'react';


type Props = {
    content: ReactNode,
    selectedStep: CREATE_ACCOUNT_STEPS,
    onChangeStep?: (step: CREATE_ACCOUNT_STEPS) => void,
    buttonsBlock: ReactNode[],
};

export const CreateAccountStep = (props: Props) => {
    const {
        content,
        selectedStep,
        onChangeStep,
        buttonsBlock,
    } = props;

    return (
        <ErrorBoundary>
            <div className={createAccount}>
                <StickyElement className={createAccountHeader}>
                    <div className={createAccountTitle}>
                        <StepHeader title="Create New Account" subTitle={STEP_TITLE[selectedStep]}/>
                        <Group>
                            {buttonsBlock}
                        </Group>
                    </div>
                    <Item style={{width: 500}} className="pd-m">
                        <CreateAccountProgressBar {...{selectedStep, onChangeStep}}/>
                    </Item>
                </StickyElement>
                <Item grow={1} className="pd-l">
                    <Group alignItems="start" direction="v" gap="xxl">
                        {content}
                    </Group>
                </Item>
            </div>
        </ErrorBoundary>
    );
};
